import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './ContactInformation.module.scss'
import { phoneNumberAction } from 'redux/actions'
import { useDispatch, useSelector } from 'react-redux'

const PhoneNumber = ({ t, validatePhoneNumber, phoneNumberError, phoneNumberValid, setIsError }) => {
  const dispatch = useDispatch()
  const [isFocussed, SetIsFocussed] = useState(false)

  const phoneNumber = useSelector((state) => state.app.phoneNumber)

  const handlePhoneNumber = (e) => {
    try {
      var x = e.currentTarget.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
      let phoneNumberParsed = !x[2] ? x[1] : x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '')
      dispatch(phoneNumberAction(phoneNumberParsed))
      // validatePhoneNumber(phoneNumberParsed)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  const handleOnBlur = () => {
    validatePhoneNumber(phoneNumber)
    SetIsFocussed(false)
  }

  return (
    <div
      className={[
        phoneNumberValid === true
          ? phoneNumber !== '' && 'form-group has-success'
          : phoneNumberValid === false && 'form-group ns-form-group-message-error',
        styles['fields_margin'],
      ].join(' ')}
    >
      <label className="control-label" htmlFor="PhoneNumber">
        <b>{t('contact_info.phone_number')}</b>
      </label>
      {phoneNumberValid === false && (
        <div className="ns-form-error-container has-error error-msg-align">
          <i className={['fa fa-exclamation-circle', styles['icon_margin_left']].join(' ')} aria-hidden="true"></i>
          <div className={isFocussed ? 'help-block-focused' : 'help-block'}>{t(phoneNumberError)}</div>
        </div>
      )}
      <input
        type="text"
        id="PhoneNumber"
        className="form-control"
        value={phoneNumber}
        onChange={handlePhoneNumber}
        // onBlur={handleOnBlur}
        onFocus={() => SetIsFocussed(true)}
        autoComplete="off"
        maxLength="12"
      />
      {phoneNumberValid === true && phoneNumber !== '' && (
        <i className={['fa fa-check-circle', styles['icon_margin_left']].join(' ')} aria-hidden="true"></i>
      )}
    </div>
  )
}

export default withTranslation('common')(PhoneNumber)
